import PropTypes from 'prop-types'

import { useStyletron } from 'baseui'
import Icon from 'baseui/icon/icon'

const IconMobile = ({ color, overrides, ref, title, style }) => {
  const [, theme] = useStyletron()

  title = title ?? 'Mobile'
  color = color ?? theme.colors.primary

  return (
    <Icon viewBox='0 0 15 22' ref={ref} title={title} overrides={overrides} style={style}>
      <title>{title}</title>
      <path d="M2 22C1.45 22 0.979167 21.8042 0.5875 21.4125C0.195833 21.0208 0 20.55 0 20V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H12C12.55 0 13.0208 0.195833 13.4125 0.5875C13.8042 0.979167 14 1.45 14 2V5.1C14.3 5.21667 14.5417 5.4 14.725 5.65C14.9083 5.9 15 6.18333 15 6.5V8.5C15 8.81667 14.9083 9.1 14.725 9.35C14.5417 9.6 14.3 9.78333 14 9.9V20C14 20.55 13.8042 21.0208 13.4125 21.4125C13.0208 21.8042 12.55 22 12 22H2ZM7.7125 18.7125C7.90417 18.5208 8 18.2833 8 18C8 17.7167 7.90417 17.4792 7.7125 17.2875C7.52083 17.0958 7.28333 17 7 17C6.71667 17 6.47917 17.0958 6.2875 17.2875C6.09583 17.4792 6 17.7167 6 18C6 18.2833 6.09583 18.5208 6.2875 18.7125C6.47917 18.9042 6.71667 19 7 19C7.28333 19 7.52083 18.9042 7.7125 18.7125Z" fill={color}/>
    </Icon>
  )
}

IconMobile.propTypes = {
  color: PropTypes.string,
  overrides: PropTypes.object,
  ref: PropTypes.object,
  title: PropTypes.string,
  style: PropTypes.object,
}

export default IconMobile
